import { IOrderState } from '@/store/order';
import { IOrderGetters } from './getters.types';
import { IOrder, Order } from '@/models';

export const getters: IOrderGetters = {
  getOrderCount(state: IOrderState): number {
    return state.count;
  },

  getOrders(state: IOrderState): IOrder[] {
    return state.orders.map(data => new Order(data));
  },

  getOrderBySeries: (state: IOrderState) => (
    series: string
  ): IOrder | undefined => {
    const data = state.orders.find(order => order.series === series);
    if (!data) {
      return undefined;
    }

    return new Order(data);
  }
};
